import omfLogo from "@/images/Logos/partners/om-logo.png"
import sprintHiveLogo from "@/images/Logos/SprintHive-Logo-grey.svg"
import finChoiceLogo from "@/images/Logos/partners/finchoice-logo.png"
import wfsLogo from "@/images/Logos/partners/wfs.png"
import rcsLogo from "@/images/Logos/partners/rcs-logo.png"
import wfsFav from "@/images/Logos/partners/wfs-fav.png"
import sanlamLogo from "@/images/Logos/partners/sanlam-logo.png"
import assupolLogo from "@/images/Logos/partners/assupol-logo.png"
import gppaLogo from "@/images/Logos/partners/gppa-logo.jpeg"
import sanlamGotymeLogo from "@/images/Logos/partners/sanlam-gotyme-logo.png"
import avisLogo from "@/images/Logos/partners/avis-logo.png"

const CDN_URLS = {
  dev: 'https://cdn.dev00.sprinthive.tech/sh-live-capture/v1',
  qa: 'https://cdn.qa00.sprinthive.tech/sh-live-capture/v1',
  prod: 'https://cdn.prod.sprinthive.com/sh-live-capture/v1'
}

const defaultFeatures = {
  locationCapture: false,
  cameraSwitch: true,
  secureStatementFeature: false,
  idvLandingButton2: false
}

// Tenant Base Configurations
const shBase = {
  tenantCode: "sh",
  name: "SprintHive",
  productName: "Credit Card",
  logo: sprintHiveLogo,
  pallet: {
    colour1: "#434A51",
    colour2: "#FFF",
    colour3: "#17BC27"
  },
  messages: {
    "outbound-sales": {
      title: "SprintHive Application",
      message: "To continue with your SprintHive application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "product-application": {
      title: "SprintHive Application",
      message: "To continue with your SprintHive application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "customer-inbound-enquiry": {
      title: "SprintHive Enquiry",
      message: "To assist you with your SprintHive enquiry, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    }
  },
  features: {...defaultFeatures, locationCapture: true}
}

const gpaaBase = {
  tenantCode: "gpaa",
  name: "GPPA",
  productName: "Authentication",
  logo: gppaLogo,
  pallet: {
    colour1: "#DE6D45",
    colour2: "#FFF",
    colour3: "#FFF"
  },
  messages: {
    "outbound-sales": {
      title: "Government Employees Pension Authentication",
      message: "To continue with your login, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "product-application": {
      title: "Government Employees Pension Authentication",
      message: "To continue with your login, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "customer-inbound-enquiry": {
      title: "Government Employees Pension Authentication",
      message: "To continue with your login, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    }
  },
  features: defaultFeatures
}

const skyBase = {
  tenantCode: "sky",
  name: "Sanlam",
  productName: "Sanlam Policy",
  logo: sanlamLogo,
  pallet: {
    colour1: "#0072c6",
    colour2: "#FFF",
    colour3: "#FFF"
  },
  messages: {
    "product-application": {
      title: "Sanlam Application",
      message: "To continue with your Sanlam policy application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "policy-application": {
      title: "Sanlam Application",
      message: "To continue with your Sanlam policy application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "customer-inbound-enquiry": {
      title: "Sanlam Enquiry",
      message: "To assist you with your Sanlam enquiry, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    }
  },
  features: {...defaultFeatures, idvLandingButton2: true}
}

const aspBase = {
  tenantCode: "asp",
  name: "Assupol",
  productName: "Assupol Policy",
  logo: assupolLogo,
  pallet: {
    colour1: "#00338d",
    colour2: "#FFF",
    colour3: "#FFF"
  },
  messages: {
    "product-application": {
      title: "Assupol Application",
      message: "To continue with your Assupol policy application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "policy-application": {
      title: "Assupol Application",
      message: "To continue with your Assupol policy application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "customer-inbound-enquiry": {
      title: "Assupol Enquiry",
      message: "To assist you with your Assupol enquiry, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    }
  },
  features: {...defaultFeatures, idvLandingButton2: true}
}

const omfBase = {
  tenantCode: "omf",
  name: "Old Mutual",
  productName: "Old Mutual Personal Loans",
  logo: omfLogo,
  pallet: {
    colour1: "#129c6e",
    colour2: "#FFF",
    colour3: "#FFF"
  },
  messages: {
    "outbound-sales": {
      title: "Old Mutual Application",
      message: "To continue with your Old Mutual application, please verify your identity by taking a photo.\n\nBy submitting your photo, you consent to the use of your facial data for identity verification purposes.\n Your data will be processed in line with the Old Mutual Privacy Notice, securely stored and will only be used for this purpose.",
      buttonText: "VERIFY USING CAMERA"
    },
    "product-application": {
      title: "Old Mutual Application",
      message: "To continue with your Old Mutual application, please verify your identity by taking a photo.\n\nBy submitting your photo, you consent to the use of your facial data for identity verification purposes.\n Your data will be processed in line with the Old Mutual Privacy Notice, securely stored and will only be used for this purpose.",
      buttonText: "VERIFY USING CAMERA"
    },
    "customer-inbound-enquiry": {
      title: "Old Mutual Enquiry",
      message: "To continue with your Old Mutual application, please verify your identity by taking a photo.\n\nBy submitting your photo, you consent to the use of your facial data for identity verification purposes.\n Your data will be processed in line with the Old Mutual Privacy Notice, securely stored and will only be used for this purpose.",
      buttonText: "VERIFY USING CAMERA"
    }
  },
  features: defaultFeatures
}

const rcsBase = {
  tenantCode: "rcs",
  name: "RCS",
  productName: "RCS Loan",
  logo: rcsLogo,
  pallet: {
    colour1: "#EA5206",
    colour2: "#FFF",
    colour3: "#FFF"
  },
  messages: {
    "product-application": {
      title: "RCS Loan Application",
      message: "To continue with your RCS Loan application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "customer-inbound-enquiry": {
      title: "RCS Enquiry",
      message: "To assist you with your RCS enquiry, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    }
  },
  features: defaultFeatures
}

const wfsBase = {
  tenantCode: "wfs",
  name: "Woolies",
  productName: "WFS Cards",
  logo: wfsLogo,
  favIcon: wfsFav,
  privacyPolicyUrl: "https://www.woolworths.co.za/corporate/cmp205289",
  pallet: {
    colour1: "#000",
    colour2: "#FFF",
    colour3: "#FFF"
  },
  messages: {
    "outbound-sales": {
      title: "Woolies Application",
      message: "To continue with your Woolies application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "outbound-sales-enquiry": {
      title: "Woolies Application",
      message: "To continue with your Woolies application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "product-application": {
      title: "Woolies Application",
      message: "To continue with your Woolies application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "customer-inbound-enquiry": {
      title: "Woolies Customer Service",
      message: "To assist you with your Woolies enquiry, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    }
  },
  features: defaultFeatures
}

// Income-only tenant — no messages or cdnUrl required
const tymeBase = {
  tenantCode: "tym",
  name: "SanlamGoTyme",
  logo: sanlamGotymeLogo,
  pallet: {
    colour1: "#0075c9",
    colour2: "#2D2D3A",
    colour3: "#1f242d"
  },
  features: defaultFeatures
}

const finChoiceBase = {
  tenantCode: "finChoice",
  name: "FinChoice",
  productName: "FinChoice Personal Loan",
  logo: finChoiceLogo,
  pallet: {
    colour1: "#2a62f5",
    colour2: "#FFF",
    colour3: "#FFF"
  },
  messages: {
    "product-application": {
      title: "FinChoice Loan Application",
      message: "To continue with your FinChoice Loan application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
    "customer-inbound-enquiry": {
      title: "FinChoice Enquiry",
      message: "To assist you with your FinChoice enquiry, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    }
  },
  features: defaultFeatures
}

const sandbox5Base = {
  tenantCode: "sandbox*5",
  name: "AVIS Budget",
  productName: "car rental",
  logo: avisLogo,
  logoWidth: '220px',
  logoHeight: '64px',
  pallet: {
    colour1: "#D4002A",
    colour2: "#FFF",
    colour3: "#FFF"
  },
  messages: {
    "product-application": {
      title: "Car Rental Application",
      message: "To continue with your AVIS Budget application, please verify your identity by taking a photo.\n\nThis photo will only be used for identity verification purposes.",
      buttonText: "VERIFY USING CAMERA"
    },
  },
  features: defaultFeatures
}


// Tenant configurations

export const tenantConfigs = [
  // SprintHive
  {...shBase, domain: ["dev00.sprinthive.tech", "localhost"], environment: "dev", cdnUrl: CDN_URLS.dev},
  {...shBase, domain: ["qa00.sprinthive.tech"], environment: "qa", cdnUrl: CDN_URLS.qa},
    // todo: map this once new sh-live-capture pte environment is setup
  // {...shBase, domain: ["integ-test.prod00.sprinthive.tech"], environment: "integ", cdnUrl: CDN_URLS.qa},
  {...shBase, domain: ["demo.pte.sprinthive.com"], environment: "uat", cdnUrl: CDN_URLS.prod},

  // GPAA
  {...gpaaBase, domain: ["gpaa-uat.pte.sprinthive.com"], environment: "uat", cdnUrl: CDN_URLS.prod},
  {...gpaaBase, domain: ["gpaa.prod.sprinthive.com"], environment: "prod", cdnUrl: CDN_URLS.prod},

  // Sanlam
  {...skyBase, domain: ["sky-uat.pte.sprinthive.com"], environment: "uat", cdnUrl: CDN_URLS.prod},
  {
    ...skyBase,
    domain: ["sky.prod.sprinthive.com"],
    environment: "prod",
    cdnUrl: CDN_URLS.prod,
    features: {...skyBase.features, cameraSwitch: false}
  },

  // Assupol
  {...aspBase, domain: ["asp-uat.pte.sprinthive.com"], environment: "uat", cdnUrl: CDN_URLS.prod},
  {...aspBase, domain: ["asp.prod.sprinthive.com"], environment: "prod", cdnUrl: CDN_URLS.prod},

  // Old Mutual
  {...omfBase, domain: ["omf-uat.pte.sprinthive.com"], environment: "uat", cdnUrl: CDN_URLS.prod},
  {...omfBase, domain: ["omf.prod.sprinthive.com"], environment: "prod", cdnUrl: CDN_URLS.prod},

  // RCS
  {...rcsBase, domain: ["rcs.uat.sprinthive.com"], environment: "uat", cdnUrl: CDN_URLS.prod},
  {...rcsBase, domain: ["rcs.prod.sprinthive.com"], environment: "prod", cdnUrl: CDN_URLS.prod},

  // Woolies
  {...wfsBase, domain: ["wfs.uat.sprinthive.com"], environment: "uat", cdnUrl: CDN_URLS.prod},
  {
    ...wfsBase,
    domain: ["wfs.prod.sprinthive.com", "verify.wfs.co.za"],
    environment: "prod",
    cdnUrl: CDN_URLS.prod
  },

  // FinChoice
  {...finChoiceBase, domain: ["sandbox-1.uat.sprinthive.com"], environment: "uat", cdnUrl: CDN_URLS.prod},

  // Sandbox-5
  {...sandbox5Base, domain: ["sandbox-5.uat.sprinthive.com"], environment: "prod", cdnUrl: CDN_URLS.prod},

  // TymeBank
  {...tymeBase, domain: ["tym-uat.pte.sprinthive.com"], environment: "uat"},
  {...tymeBase, domain: ["tym.prod.sprinthive.com"], environment: "prod"}
]

export const findTenantByDomain = domain => {
  return tenantConfigs.find(tenant => tenant.domain.includes(domain))
}

export const findTenantByTenantCode = code => {
  return tenantConfigs.find(tenant => tenant.tenantCode === code)
}
